module.exports = __webpack_public_path__ + "img/bg.1f9ca207.jpg";